import { ethers } from 'ethers';
import { useEffect, useState } from 'react';
import { NATIVE_CURRENCY_PRECISION } from '@orionprotocol/sdk';
import { i18n } from '@lingui/core';
import { isNativeCurrency } from '@orionprotocol/common';
import { useERC20Contract } from '@orionprotocol/utils';

 
import { displayError } from '../../utils';

export function useTokenDecimals(
  tokenAddress: string | undefined,
  provider: ethers.Provider | undefined,
): number | undefined {
  const [decimals, setDecimals] = useState<number>();
  const contract = useERC20Contract(tokenAddress, provider);

  useEffect(() => {
    if (isNativeCurrency(tokenAddress)) {
      setDecimals(NATIVE_CURRENCY_PRECISION);
    }
  }, [tokenAddress]);

  useEffect(() => {
    contract
      ?.decimals()
      .then(Number)
      .then(setDecimals)
      .catch((e) => {
        setDecimals(undefined);
        displayError(i18n._('Error getting token decimals'))(e);
      });
  }, [contract]);

  return decimals;
}
